exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pdf_viewer[data-v-c9538036]{width:70%;height:800px}.title[data-v-c9538036]{color:#0032a0}.header-table-divider[data-v-c9538036]{margin-top:2%}.btn-new-identity[data-v-c9538036]{background-color:#0032a0!important;color:#fff}.v-btn[data-v-c9538036]{text-transform:none}.button-container[data-v-c9538036]{align-items:center;justify-content:center;display:flex}.pdf-wrapper[data-v-c9538036]{margin-bottom:150px}.pdf-wrapper .document-pdf[data-v-c9538036]{width:550px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c9538036","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/approval/ShowApproval.vue
// module id = 1048
// module chunks = 0